
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n          ', badge, '\n        ');
                }
                function scopeColorArrColorImageUrl2(colorOption, colorOptionIndex) {
                    var colorArr = colorOption.split('|');
                    var color = colorArr[0];
                    var image = colorArr[1];
                    var url = colorArr[2];
                    return [_createElement('a', {
                            'className': 'product-color-swatch swatch-element color' + (colorOptionIndex >= 4 ? ' hidden' : ''),
                            'data-product-id': 'product-' + this.id,
                            'data-option-image': image,
                            'title': color,
                            'href': url,
                            'key': '30561'
                        }, _createElement('img', { 'src': image }))];
                }
                function repeatColorOption3(colorOption, colorOptionIndex, colorArr, color, image, url) {
                    return scopeColorArrColorImageUrl2.apply(this, [
                        colorOption,
                        colorOptionIndex
                    ]);
                }
                function repeatI4(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', { 'className': 'halo-item' }, _createElement('div', {
                    'className': 'product-card layout-1',
                    'data-product-id': 'product-' + this.id,
                    'data-id': this.id
                }, _createElement('div', { 'className': 'product-image' }, _createElement('a', {
                    'className': 'product_wishlist wishlist',
                    'href': '#',
                    'aria-label': 'wishlist',
                    'data-icon-wishlist': true,
                    'data-product-handle': this.handle,
                    'data-id': this.id
                }, _createElement('svg', { 'className': 'icon' }, _createElement('use', { 'xlinkHref': '#icon-heart' }))), _createElement.apply(this, [
                    'div',
                    { 'className': 'product_badges' },
                    !this.out_of_stock && this.on_sale ? _createElement('div', {
                        'className': 'badge sale-badge sale-badge-2',
                        'key': '441'
                    }, '\n          -', this.calcDiscount(this.price, this.compare_at_price), '%\n        ') : null,
                    this.out_of_stock ? _createElement('div', {
                        'className': 'badge soldOut-badge',
                        'key': '626'
                    }, 'Sold Out') : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ]), _createElement('a', {
                    'className': 'product-link' + (this.image2 ? ' image-swap' : ''),
                    'href': this.url,
                    'aria-label': 'link'
                }, _createElement('img', {
                    'className': (this.image2 ? 'image-one ' : '') + 'lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'image-two lazyautosizes lazyloaded',
                    'src': this.resizeImage(this.image2),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '1207'
                }) : null), _createElement('a', {
                    'className': 'product-quickview',
                    'aria-label': 'quickview',
                    'id': this.handle,
                    'data-quickview': true,
                    'aria-describedby': 'a11y-external-message'
                }, '\n        Quick View\n      '), _createElement('div', { 'className': 'product-action' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'variants',
                    'id': 'list-product-form-' + this.id,
                    'data-id': 'product-actions-' + this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'btn product-btn',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '17651'
                    }, '\n              ', this.out_of_stock ? 'Sold out' : 'Select options', '\n            ')] : null, this.variant_ids.length === 1 ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '20331'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '20333'
                    }),
                    _createElement('button', {
                        'data-btn-addtocart': true,
                        'className': 'btn product-btn',
                        'type': 'submit',
                        'data-form-id': '#list-product-form-' + this.id,
                        'disabled': this.out_of_stock,
                        'key': '20335'
                    }, this.out_of_stock ? ['Sold out'] : null, !this.out_of_stock ? [
                        '\n                Add to cart',
                        this.set_qty ? ` Set of ${ this.set_qty }` : '',
                        '\n              '
                    ] : null)
                ] : null))), _createElement('div', { 'className': 'product-content' }, _createElement('div', { 'className': 'product-detail' }, this.product_colors && this.product_colors.length > 1 ? _createElement('div', {
                    'className': 'product-color-swatch-container',
                    'key': '2801'
                }, _createElement('span', { 'className': 'form-label' }, 'Color', _createElement('em', {}, '*')), _createElement.apply(this, [
                    'div',
                    { 'className': 'product-color-swatch-list-container swatch' },
                    _map(this.product_colors, repeatColorOption3.bind(this)),
                    this.product_colors.length > 5 ? [_createElement('a', {
                            'className': 'product-color-swatch show-more',
                            'key': '35551'
                        }, '+', this.product_colors.length - 4)] : null
                ])) : null, _createElement('div', { 'className': 'product-vendor' }, this.vendor && this.vendor_url ? _createElement('a', Object.assign({}, {
                    'href': this.vendor_url,
                    'title': this.removeHTML(this.vendor),
                    'key': '3809'
                }, { dangerouslySetInnerHTML: { __html: this.vendor } })) : null), _createElement('h4', { 'className': 'product-title' }, _createElement('a', Object.assign({}, {
                    'href': this.url,
                    'aria-label': 'title'
                }, { dangerouslySetInnerHTML: { __html: this.breakWordOnSlash(this.title) } }))), _createElement('div', { 'className': 'product-price' + (this.on_sale && !this.price_varies ? ' price--on-sale' : '') }, this.on_sale && !this.price_varies ? _createElement('span', {
                    'className': 'price-item price-item--regular',
                    'key': '4322'
                }, _createElement('span', { 'className': 'money' }, this.formatPrice(this.compare_at_price))) : null, _createElement('span', { 'className': 'price-item ' + (this.on_sale && !this.price_varies ? 'price-item--sale' : 'price-item--regular') }, this.price_varies ? _createElement('span', { 'key': '4676' }, 'From: ') : null, _createElement('span', { 'className': 'money' }, this.formatPrice(this.price))), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price-item price-item--set',
                    'key': '4820'
                }, '\n            Set of ', this.set_qty, ': ', this.formatPrice(this.price * this.set_qty), '\n          ') : null), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '50340'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI4.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '5440'
                }) : null, this.body_html && this.view === '1' ? _createElement('div', mergeProps({
                    'className': 'product-description',
                    'key': '5580'
                }, { dangerouslySetInnerHTML: { __html: this.body_html } })) : null), _createElement('div', { 'className': 'product-actions' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'variants',
                    'id': 'list-product-form-' + this.id,
                    'data-id': 'product-actions-' + this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 || this.ProductScope === 'master' ? [_createElement('a', {
                        'className': 'btn product-btn',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '59651'
                    }, '\n              ', this.out_of_stock ? 'Sold out' : 'Select options', '\n            ')] : null, this.variant_ids.length === 1 && (!this.ProductScope || this.ProductScope === 'child') ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '62771'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '62773'
                    }),
                    _createElement('button', {
                        'data-btn-addtocart': true,
                        'className': 'btn product-btn',
                        'type': 'submit',
                        'data-form-id': '#list-product-form-' + this.id,
                        'disabled': this.out_of_stock,
                        'key': '62775'
                    }, this.out_of_stock ? ['Sold out'] : null, !this.out_of_stock ? [
                        '\n                Add to cart',
                        this.set_qty ? ` Set of ${ this.set_qty }` : '',
                        '\n              '
                    ] : null)
                ] : null), _createElement('button', {
                    'className': 'wishlist btn btn--secondary',
                    'data-icon-wishlist': true,
                    'data-product-handle': this.handle,
                    'data-id': this.id
                }, _createElement('span', { 'className': 'add' }, 'Add to Wish List'), _createElement('span', { 'className': 'remove' }, 'Remove Wish List'))))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products container' }, _createElement('div', { 'className': 'section-header text-left cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []